import PropTypes from 'prop-types'
import cx from 'classnames'
import setQuery from 'set-query-string'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { trackEvent } from '../../../../../gtm'
import { parseQuery, roundPrice } from '../../../../../utils'
import { convertCurrency } from '../../../../helpers/PriceConverter'
import styles from './StepsBar.module.scss'

StepsBar.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.node.isRequired,
      shortText: PropTypes.node.isRequired,
    }),
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  currency: PropTypes.string,
}

export default function StepsBar({ steps, currentStep, setStep, currency }) {
  const totalPrice = useSelector((state) => state.totalPrice)

  useEffect(() => {
    if(totalPrice) {
      trackEvent({
        checkout_cart_value: roundPrice(convertCurrency(totalPrice, currency, 'USD')),
      })
    }
  }, [currentStep, totalPrice])

  return (
    <div className={styles.bar}>
      {steps.map((step, index) => {
        const stepNumber = index + 1
        const isFinished = currentStep > stepNumber
        const isActive = currentStep === stepNumber
        const onClick = () => {
          if(!isFinished && !isActive) { return }
          // Preserve the ?version A/B flag when resetting the query — otherwise
          // a later refresh loses it and falls back to the old design.
          const { version } = parseQuery()
          setQuery(version ? { version } : {}, { clear: true })
          setStep(stepNumber)
        }
        return (
          <div
            key={stepNumber}
            onClick={onClick}
            className={cx(styles.item, {
              [styles.finished]: isFinished,
              [styles.active]: isActive,
            })}
          >
            <span className={styles.circle}>{stepNumber}</span>
            <span className={cx(styles.label, styles.full)}>{step.text}</span>
            <span className={cx(styles.label, styles.short)}>{step.shortText}</span>
            {stepNumber !== steps.length && <span className={styles.delimiter} />}
          </div>
        )
      })}
    </div>
  )
}
